import React from 'react'
import Container from 'react-bootstrap/Container';
//import Row from 'react-bootstrap/Row';
/*import vigenereImg from '../../vigenere.png'*/
import vigenereGif from '../../assets/vigenere.gif'
import { PageSection } from '../Sections/PageSection';
/*import faImg from '../../fa.png'*/
import faGif from '../../assets/fa.gif'
/*import colorConverterImg from '../../colorconverter.png'*/
import colorConverterGif from '../../assets/colorconverter.gif'
import { LinkButton } from './LinkButton';
import { HeadingBlock } from './HeadingBlock';
import { Helmet } from "react-helmet-async";
//import Col from 'react-bootstrap/Col';

export const Home = () => {
    return (
        <>
            <Helmet>
                <title>Cipher Centre | Free Encryption, Decryption & Text Tools</title>
                <meta
                    name="description"
                    content="Cipher Centre offers free tools for encrypting & decrypting classical ciphers with visual aids. Also includes text analysis, encoding/decoding, and color conversion tools."
                />
                <link rel="canonical" href="https://ciphercentre.com" />
            </Helmet>

            <PageSection>
                <h1 className='home-heading'>Welcome to CipherCentre.com</h1>
            </PageSection>
            {/*  <hr />*/}
            <PageSection>
                <HeadingBlock title="Classical Ciphers" />
            </PageSection>
            <PageSection>

                <div className="page-section__columns">
                    <div className="page-section__column">

                        <div className="mt-4">
                            <p>Encode or decode text using classical <a className="link" href="/cipher-tools">ciphers</a>, such as <a className="link" href="/cipher-tools/caesar-cipher">Caesar</a> or <a className="link" href="/cipher-tools/vigenere-cipher">Vigenere</a>.</p>
                            <p>Classical ciphers are cryptographic techniques that transform plaintext into ciphertext, making it unreadable to unauthorized eyes. These ciphers offer both a fascinating glimpse into the past and a powerful learning experience in the field of cryptography.</p>
                            <p>Each cipher includes a board designed to provide a visual representation and facilitate understanding of how the specific cipher operates.</p>
                        </div>

                    </div>
                    <div className="page-section__column">
                        <a href="/cipher-tools/vigenere-cipher"><img className='responsive-img' src={vigenereGif} alt="vigenere cipher" /></a>
                    </div>
                </div>

            </PageSection>
            <PageSection>
                <HeadingBlock title="Text Tools" />
            </PageSection>
            <PageSection>
                <div className="page-section__columns">
                    <div className="page-section__column">
                        <a href="/text-tools/analyse-frequency"><img className='responsive-img' src={faGif} alt="frequency analysis" /></a>
                    </div>
                    <div className="page-section__column">

                        <div className="mt-4">
                            {/*<p>Welcome to our <a className="link" href="/text-tools">Text Tools</a> playground! Here, we've got a bunch of cool tools to play around with your words.</p>*/}
                            {/*<p>Whether you're a word wizard, a data geek, or just curious about language, we've got something for you.</p>*/}
                            <p>Welcome to the <a className="link" href="/text-tools">Text Tools</a> playground — a space to explore, experiment, and get more out of your words.</p>
                            <p> Whether you're working with language, analyzing text, or just curious to see what’s possible, you’ll find tools here to help you dig in and have fun.</p>
                        </div>

                    </div>
                </div>
            </PageSection>
            {/*   <hr />*/}
            <PageSection>
                <HeadingBlock title="Other Tools" />
            </PageSection>
            <PageSection>
                <div className="page-section__columns">
                    <div className="page-section__column">

                        <div className="mt-4">
                            <p>Welcome to the <a className="link" href="/misc-tools">Miscellanious Tools</a> section. While still under development, there are few tools to choose from such as <a className="link" href="/misc-tools/convert-color">Color Converter</a> or <a className="link" href="/misc-tools/convert-encodings">Multi Conversion</a> tool, which allows for easy convertion between Plaintext, Binary, Base 64 and Hexadecimal</p>
                            <p>New tools are on the way so if you're interested check back often.</p>
                        </div>

                    </div>
                    <div className="page-section__column">
                        <a href="/misc-tools/convert-color"><img className='responsive-img' src={colorConverterGif} alt="convert color" /></a>
                    </div>
                </div>

            </PageSection>

        </>

    )
}
